import { useCurrentUser } from '@zapier/design-system-revenue/src/hooks';
import { isBrowser } from '@zapier/design-system-revenue/src/utils';

type UserCurrentAccountResult = {
  accountId: number | undefined;
  error: string | undefined;
  isLoading: boolean;
};

type Props = {
  skip?: boolean;
};

export const useCurrentAccountId = ({
  skip,
}: Props = {}): UserCurrentAccountResult => {
  const { currentUser, error, isLoading } = useCurrentUser({ skip });

  const response = {
    accountId: undefined,
    error: error ? 'Error loading current account ID.' : undefined,
    isLoading,
  };

  if (!currentUser || !isBrowser()) {
    return response;
  }

  /**
   * This can actually return a value even if the user isn't logged in.
   * So we need to make sure the user's actually logged in before returning
   * the currentAccountId.
   */
  const currentAccountId = localStorage.getItem('currentAccountId');

  return {
    ...response,
    accountId: currentAccountId ? parseInt(currentAccountId) : undefined,
  };
};
